export function validNif(val) {
  if (!val) { return true; }
  let valid = true;
  // console.log('NIF ' + val)
  let decode_table = {
    0: 'T',
    1: 'R',
    2: 'W',
    3: 'A',
    4: 'G',
    5: 'M',
    6: 'Y',
    7: 'F',
    8: 'P',
    9: 'D',
    10: 'X',
    11: 'B',
    12: 'N',
    13: 'J',
    14: 'Z',
    15: 'S',
    16: 'Q',
    17: 'V',
    18: 'H',
    19: 'L',
    20: 'C',
    21: 'K',
    22: 'E',
  }
  if (val.slice(-1).toUpperCase() != decode_table[parseInt(val.slice(0, -1)) % 23]) {
    valid = false;
  }
  return valid;
}

export function validNie(val) {
  if (!val) { return true; }
  // console.log('NIE ' + val)

  if (!["X", "Y", "Z"].includes(val[0].toUpperCase())) {
    return false;
  }

  // console.log(["X", "Y", "Z"].findIndex((m_el) => (m_el === val[0].toUpperCase())) )
  val = (["X", "Y", "Z"].findIndex((el) => (el == val[0].toUpperCase()))).toString() + val.slice(1);
  let valid = true;
  let decode_table = {
    0: 'T',
    1: 'R',
    2: 'W',
    3: 'A',
    4: 'G',
    5: 'M',
    6: 'Y',
    7: 'F',
    8: 'P',
    9: 'D',
    10: 'X',
    11: 'B',
    12: 'N',
    13: 'J',
    14: 'Z',
    15: 'S',
    16: 'Q',
    17: 'V',
    18: 'H',
    19: 'L',
    20: 'C',
    21: 'K',
    22: 'E',
  }
  if (val.slice(-1).toUpperCase() != decode_table[parseInt(val.slice(0, -1)) % 23]) {
    valid = false;
  }
  return valid;
}


export function validCif(val) {
  if (!val) { return true; }
  // console.log('CIF ' + val)

  let valid;
  if (val.length != 9) {
    return false;
  }
  let valid_first = ["A", "B", "C", "D", "E", "F", "G",
    "H", "J", "N", "P", "Q", "R", "S",
    "U", "V", "W"];
  if (!valid_first.includes(val[0].toUpperCase())) {
    return false;
  }
  let cif_type = "else";
  if (["P", "Q", "R", "S", "W"].includes(val[0].toUpperCase()) || parseInt(val.slice(1, 3)) == 0) {
    if (!isNaN(val.slice(-1))) {
      return false;
    }
    cif_type = "letter";
  }
  if (["A", "B", "E", "H"].includes(val[0].toUpperCase())) {
    if (isNaN(parseInt(val.slice(-1)))) {
      return false;
    }
    cif_type = "number";
  }
  let last_dig = val.slice(-1);
  val = val.slice(1, 8);
  let a = 0;
  let b = 0;
  for (let i = 0; i < val.length; i++) {
    if ((i + 1) % 2 == 0) {
      a += parseInt(val[i]);
    } else {
      b += (((parseInt(val[i])) * 2).toString().split('')).reduce((acc, v) => (acc + parseInt(v)), 0);
    }
  }
  let c = a + b;
  let e = parseInt(c.toString().split('').slice(-1));
  let d = 0;
  if (e != 0) {
    d = 10 - e;
  }

  let ctrl_dig = d;
  let decode_table = {
    0: 'J',
    1: 'A',
    2: 'B',
    3: 'C',
    4: 'D',
    5: 'E',
    6: 'F',
    7: 'G',
    8: 'H',
    9: 'I'
  }
  let ctrl_lett = decode_table[d];
  valid = false;
  if (cif_type == "number") {
    if (ctrl_dig == last_dig) { valid = true; }
  } else if (cif_type == "letter") {
    if (ctrl_lett == last_dig) { valid = true; }
  } else {
    if (ctrl_lett == last_dig || ctrl_dig == last_dig) { valid = true; }
  }

  return valid;
}